import { useEffect } from 'react';

export function useInitialInResultRedirect({ history, id, isResult, initData }) {
    const sponsorRouteName = getSponsorRouteName(initData);
    useEffect(() => {
        if (sponsorRouteName && isResult && history.action === 'POP') {
            history.replace(`/${sponsorRouteName}/${id}${history.location.search}`);
        }
    }, [isResult, history, id, sponsorRouteName]);
}

export function useRedirectSponsorName({ initData, routeSponsor, history }) {
    const sponsorRouteName = getSponsorRouteName(initData);
    useEffect(() => {
        if (sponsorRouteName && routeSponsor !== sponsorRouteName) {
            const resetRoute = history.location.pathname.replace(
                `/${routeSponsor}/`,
                `/${sponsorRouteName}/`
            );
            history.replace(`${resetRoute}${history.location.search}`);
        }
    }, [sponsorRouteName, history, routeSponsor]);
}

function getSponsorRouteName(initData = {}) {
    const sponsorId = initData?.sponsorId;
    const sponsorName = initData?.sponsorName;
    // when sponsorName empty routeName will use sponsorId
    const sponsorRouteName = sponsorName || sponsorId;
    return sponsorRouteName;
}

export function useCheckIsRedirectForm(initData, id, history) {
    if (!initData) {
        return;
    }

    const {
        settings: {
            form: { redirectUrl = false }
        }
    } = initData;

    if (redirectUrl) {
        history.replace(`/${id}/redirect${window.location.search}`);
    }
}
